import { ReactElement } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@mui/material'
import { SaveButton } from '@ui/actions'
import { useElementLabel } from '@editorHooks'
import StiffeningElementForm from './StiffeningElementForm'

interface Props {
  intervals: StiffeningSegment[]
  onSave: () => void
  isLoading: boolean

  selectedStiffeningElement?: string
  setlectStiffeningElement: (guid: string) => void
}

const StiffeningElementList = ({
  intervals,
  onSave,
  isLoading,
  selectedStiffeningElement,
  setlectStiffeningElement,
}: Props): ReactElement => {
  const getElementLabel = useElementLabel()

  return (
    <>
      <Box>
        {intervals.map(({ guid }) => (
          <Accordion
            key={guid}
            expanded={guid === selectedStiffeningElement}
            onChange={(_, expanded) => {
              if (expanded) setlectStiffeningElement(guid as string)
            }}
          >
            <AccordionSummary
              key={guid}
              expandIcon={<ExpandMoreIcon sx={{ padding: 0 }} />}
              aria-controls="panel1a-content"
              id={guid}
              sx={{ paddingX: 1, paddingY: 0.5 }}
            >
              <Typography data-cy="stiffening-element-label">
                Aussteifendes Element {getElementLabel(guid as string)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <StiffeningElementForm
                FORM_ID={String(guid).split('-').join('')}
                onSave={onSave}
                stiffeningElementGuid={guid as string}
              />
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
      {!!intervals.length && (
        <Box display="flex" justifyContent="end" marginY={2}>
          <SaveButton
            type="submit"
            data-cy="btn-save"
            form={String(selectedStiffeningElement).split('-').join('')}
            loading={isLoading}
            sx={{ paddingX: 1, paddingY: 0 }}
            fullWidth
          >
            Speichern
          </SaveButton>
        </Box>
      )}
    </>
  )
}

export default StiffeningElementList
